import axios from "axios";

export const MEMBER_TOKEN_KEY = "gtg_member_token";

const memberApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

memberApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(MEMBER_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default memberApi;
